
export const discountDropOption = [{ value: 1, label: "Rs" }, { value: 2, label: "%" }];

